import * as React from 'react'
import { Button, CONTRAST_BUTTON, SIZE_SMALL } from '@mds/mds-reactjs-library'
import CenteredViewLayout from '../components/CenteredViewLayout'
import { classes } from '../components/ViewLayout'
import { ExpiredLinkIllustration } from '../components/Illustrations'
import { ArrowRightIcon } from '../icons'
import type { AuthState } from '../types/AuthState'
import type { Customization } from '../types/Customization'

type SessionTimeoutProps = {
  authState: AuthState
  customization?: Customization
}

const title = 'Session Timeout'

const defaultEnrollmentTeamName = 'McKinsey'

const SessionTimeout = ({ authState, customization }: SessionTimeoutProps): JSX.Element => {
  const enrollmentTeamName = customization?.enrollmentTeamName || defaultEnrollmentTeamName

  const text = (
    <p>
      The session has timed out and is no longer valid.
      <br />
      Return to {customization?.enrollmentTeamName || defaultEnrollmentTeamName} and try logging in again.
    </p>
  )

  const continueButton = () => {
    if (customization?.enrollmentHomeUrl) {
      globalThis.location.assign(customization.enrollmentHomeUrl)

      return
    }
    const url = new URL(authState.actionUri)
    url.searchParams.set('reset', 'true')
    globalThis.location.assign(url.toString())
  }

  return (
    <CenteredViewLayout illustration={<ExpiredLinkIllustration />} title={title}>
      {text}
      <Button
        onClick={continueButton}
        className={classes.ctaButton}
        appearance={CONTRAST_BUTTON}
        size={SIZE_SMALL}
        styles={{
          backgroundColor: customization?.buttonBackgroundColor,
          color: customization?.buttonTextColor,
        }}
      >
        Return to {enrollmentTeamName} <ArrowRightIcon stroke={customization?.buttonTextColor} />
      </Button>
    </CenteredViewLayout>
  )
}

export default SessionTimeout
